import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Route, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";

// core components
import ProLayout from "./layouts/Pro.js";

import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import configureStore from "./store/configure-store";
import CookieConsent from "react-cookie-consent";

// import AOS from "aos";
// import "aos/dist/aos.css";
import "app.css";
import ProLoginPage from "./views/Pages/ProLoginPage";
import ProRegisterPage from "./views/Pages/ProRegisterPage";
import MaintenancePage from "views/Pages/MaintenancePage.js";

// AOS.init({
//   aos: "flip-left",
//   // disable: "mobile",
//   duration: 2000
// });

const history = createBrowserHistory();

const store = configureStore(history);

ReactDOM.render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<Switch>
				<Route exact path="/" component={ProLoginPage} />
				<Route exact path="/connexion" component={ProLoginPage} />
				<Route path="/enregistrement" component={ProRegisterPage} />
				<Route exact path="/maintenance" component={MaintenancePage} />
				<Route path="/pro" component={ProLayout} />
				<Redirect to="/" />
			</Switch>
		</ConnectedRouter>
		<CookieConsent buttonText="C'est noté">
			Nous utilisons des cookies pour vous garantir la meilleure expérience sur
			notre site web. Si vous continuez à utiliser ce site, nous supposerons que
			vous êtes satisfait.
		</CookieConsent>
	</Provider>,
	document.getElementById("root")
);

// document.onreadystatechange = function() {
//   if (document.readyState === "complete") {
//     AOS.refresh();
//   }
// };
